var AlignmentTypes;
(function (AlignmentTypes) {
    AlignmentTypes["LEFT"] = "left";
    AlignmentTypes["RIGHT"] = "right";
})(AlignmentTypes || (AlignmentTypes = {}));

export { AlignmentTypes };
